export default "/images/vendor/flag-icon-css/flags/1x1/tv.svg?c87adc622981a557f7a5e841ea9ad1a6";